import React from "react";
import { TextField, Grid, Button, Box, Typography } from "@mui/material";
import { EntraUser } from "../../../../../services/profileService/model/entraUser/EntraUser";

interface ManualUserEntryProps {
  user: EntraUser | null;
  onChange: (user: EntraUser) => void;
  onCancel?: () => void;
}

/**
 * Component for manually entering user details when creating a ticket
 */
export const ManualUserEntry: React.FC<ManualUserEntryProps> = ({
  user,
  onChange,
  onCancel,
}) => {  // Update user object with changed field
  const handleInputChange = (field: keyof EntraUser, value: string) => {
    const updatedUser = { ...(user || new EntraUser()), [field]: value };
    onChange(updatedUser);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
        Enter user information manually
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>          <TextField
            fullWidth
            required
            label="User Name"
            value={user?.displayName || ''}
            onChange={(e) => handleInputChange("displayName", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="John Smith"
          />
        </Grid>
        <Grid item xs={12} md={6}>          <TextField
            fullWidth
            required
            label="Email"
            value={user?.mail || ''}
            onChange={(e) => handleInputChange("mail", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="john.smith@example.com"
            type="email"
          />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="User Principal Name"
            value={user?.userPrincipalName || ''}
            onChange={(e) => handleInputChange("userPrincipalName", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="john.smith@example.com"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Department"
            value={user?.department || ''}
            onChange={(e) => handleInputChange("department", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="IT"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Job Title"
            value={user?.jobTitle || ''}
            onChange={(e) => handleInputChange("jobTitle", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Software Engineer"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Company Name"
            value={user?.companyName || ''}
            onChange={(e) => handleInputChange("companyName", e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Company Name"
          />
        </Grid> */}
        {onCancel && (
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={onCancel}
                size="small"
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
